import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule} from '@angular/forms';
import { FormsModule } from '@angular/forms';

import { InputsModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { GridModule, ExcelModule  } from '@progress/kendo-angular-grid';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule, CalendarModule, DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { PopupModule } from '@progress/kendo-angular-popup';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { UploadModule } from '@progress/kendo-angular-upload';

import { QuillModule } from 'ngx-quill';
import { LaddaModule } from 'angular2-ladda';

import { MinimizeSidebarDirective } from './directives/minimize-sidebar.directive';
import { SideNavigationDirective } from './directives/side-navigation.directive';
import { CheckCapslockDirective } from './directives/check-capslock.directive';
import { ControlMessagesComponent } from './control-messages/control-messages';
import { 
    EpaDatepickerComponent, 
    EpaDropdownlistComponent,
    EpaInputComponent,
    EpaMultiselectComponent,
    EpaNumerictextboxComponent,
    EpaTextareaComponent,
    EpaEditorComponent
} from './custom-control-components';

import { PageHeaderComponent } from './page-header/page-header.component';
import { SectionsComponent } from './section/section.component';
import { PasswordVerificationComponent } from './password-verification/password-verification.component';
import { SectionEditFormComponent } from './section-edit-form/section-edit-form.component';
import { SafeHtmlPipe } from './pipes/safe-html';
import { GridSearchComponent } from './grid-search/grid-search.component';
import { ArraySortPipe } from './pipes/array-sort.pipe';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        InputsModule,
        DropDownsModule,
        GridModule,
        ExcelModule,
        ButtonsModule,
        DateInputsModule,
        CalendarModule,
        DatePickerModule,
        PopupModule,
        ExcelExportModule,
        DialogsModule,
        LayoutModule,
        UploadModule,
        QuillModule,
        LaddaModule
    ],
    exports: [
        ReactiveFormsModule,
        InputsModule,
        DropDownsModule, 
        GridModule,
        ExcelModule,
        ButtonsModule,
        DateInputsModule,
        CalendarModule,
        DatePickerModule,
        PopupModule,
        ExcelExportModule,
        DialogsModule,
        LayoutModule,
        UploadModule,
        QuillModule,
        LaddaModule,
        MinimizeSidebarDirective,
        SideNavigationDirective,
        CheckCapslockDirective,
        EpaDatepickerComponent,
        EpaDropdownlistComponent,
        EpaInputComponent,
        EpaMultiselectComponent,
        EpaNumerictextboxComponent,
        EpaTextareaComponent,
        EpaEditorComponent,
        ControlMessagesComponent,
        PageHeaderComponent,
        SectionsComponent,
        PasswordVerificationComponent,
        SectionEditFormComponent,
        SafeHtmlPipe,
        ArraySortPipe,
        GridSearchComponent
    ],
    declarations: [
        MinimizeSidebarDirective,
        SideNavigationDirective,
        CheckCapslockDirective,
        EpaDatepickerComponent,
        EpaDropdownlistComponent,
        EpaInputComponent,
        EpaMultiselectComponent,
        EpaNumerictextboxComponent,
        EpaTextareaComponent,
        EpaEditorComponent,
        ControlMessagesComponent,
        PageHeaderComponent,
        SectionsComponent,
        PasswordVerificationComponent,
        SectionEditFormComponent,
        SafeHtmlPipe,
        ArraySortPipe,
        GridSearchComponent
    ],
    providers: []
})
export class SharedModule { }
